// Chakra imports
import {
  Portal,
  Box,
  useDisclosure,
  useColorModeValue,
} from "@chakra-ui/react";
import Footer from "components/footer/FooterAdmin";
// Layout components
import Navbar from "components/navbar/NavbarAdmin";
import Sidebar from "components/sidebar/Sidebar";
import { SidebarContext } from "contexts/SidebarContext";
import useScrollToTop from "hooks/useScrollToTop";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Redirect, Route, Switch, useHistory } from "react-router-dom";
import { FetchAccountDetails } from "listener/signin/action";
import routes from "routes";
import { useInvoicesStore } from "store/invoiceStore";

// Custom Chakra theme
export default function Dashboard(props: { [x: string]: any }) {
  const { ...rest } = props;
  useScrollToTop();
  const history = useHistory();
  // states and functions
  const [fixed] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(false);
  // functions for changing the states from components
  const getRoute = () => {
    return window.location.pathname !== "/admin/full-screen-maps";
  };

  const token = localStorage.getItem("jwtToken");

  const fetchInvoices = useInvoicesStore((state) => state.fetchInvoices);
  const dispatch = useDispatch();

  useEffect(() => {
    if (token) {
      fetchInvoices();
      dispatch(FetchAccountDetails());
    }
  }, [fetchInvoices, dispatch, token]);

  const getActiveRoute = (routes: RoutesType[]): string => {
    let activeRoute = "Edit Campaign";
    for (let i = 0; i < routes.length; i++) {
      if (window.location.href.indexOf(routes[i].path) !== -1) {
        return routes[i].name;
      }
    }
    return activeRoute;
  };
  const getActiveNavbar = (routes: RoutesType[]): boolean => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (window.location.href.indexOf(routes[i].path) !== -1) {
        return routes[i].secondary;
      }
    }
    return activeNavbar;
  };
  const getActiveNavbarText = (routes: RoutesType[]): string | boolean => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (window.location.href.indexOf(routes[i].path) !== -1) {
        return routes[i].name;
      }
    }
    return activeNavbar;
  };

  const layout = token ? "/" : "/auth";

  const getRoutes = (routes: RoutesType[]): any => {
    return routes
      .flatMap((route: RoutesType, key: any) => {
        if (route.layout === layout) {
          const routeComponent = (
            <Route
              exact
              path={route.path}
              component={route.component}
              key={key}
            />
          );

          if (route.subRoutes) {
            return [
              routeComponent,
              ...route.subRoutes.map((subRoute, subKey) => (
                <Route
                  exact
                  path={subRoute.path}
                  component={subRoute.component}
                  key={`${key}-${subKey}`}
                />
              )),
            ];
          }

          return routeComponent;
        }
        return null;
      })
      .filter(Boolean);
  };

  document.documentElement.dir = "ltr";
  document.title = "Gamelight - " + getActiveNavbarText(routes);
  const { onOpen } = useDisclosure();
  const authBg = useColorModeValue("white", "navy.900");

  if (!token) {
    return (
      <Box>
        <SidebarContext.Provider
          value={{
            toggleSidebar,
            setToggleSidebar,
          }}
        >
          <Box
            bg={authBg}
            float="right"
            minHeight="100vh"
            height="100%"
            position="relative"
            w="100%"
            transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
            transitionDuration=".2s, .2s, .35s"
            transitionProperty="top, bottom, width"
            transitionTimingFunction="linear, linear, ease"
          >
            {getRoute() ? (
              <Box mx="auto" minH="100vh">
                <Switch>
                  {getRoutes(routes)}
                  <Redirect from="/" to="/login" />
                </Switch>
              </Box>
            ) : null}
          </Box>
        </SidebarContext.Provider>
      </Box>
    );
  }

  return (
    <Box>
      <SidebarContext.Provider
        value={{
          toggleSidebar,
          setToggleSidebar,
        }}
      >
        <Sidebar routes={routes} display="none" {...rest} />
        <Box
          float="right"
          minHeight="100vh"
          height="100%"
          overflow="auto"
          position="relative"
          maxHeight="100%"
          w={{ base: "100%", xl: "calc( 100% - 250px )" }}
          maxWidth={{ base: "100%", xl: "calc( 100% - 250px )" }}
          transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
          transitionDuration=".2s, .2s, .35s"
          transitionProperty="top, bottom, width"
          transitionTimingFunction="linear, linear, ease"
        >
          <Portal>
            <Box>
              <Navbar
                onOpen={onOpen}
                brandText={getActiveRoute(routes)}
                secondary={getActiveNavbar(routes)}
                message={getActiveNavbarText(routes)}
                fixed={fixed}
                {...rest}
              />
            </Box>
          </Portal>

          {getRoute() ? (
            <Box
              mx="auto"
              p={{ base: "20px", md: "30px" }}
              pe="20px"
              minH="100vh"
              pt="50px"
            >
              <Switch>
                {getRoutes(routes)}
                <Redirect from="/" to="/ua" />
              </Switch>
            </Box>
          ) : null}
          <Box>
            <Footer />
          </Box>
        </Box>
      </SidebarContext.Provider>
    </Box>
  );
}
